import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes
} from "react-router-dom";
import { ROUTES } from "./constants";
import { Checkpoint } from "../checkpoint";
import { Checker } from "../checker";
import Account from "../account";
import FormAppeal from "src/form";

const RootComponent: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* <Route path={ROUTES.HOMEPAGE_ROUTE} element={<Page1 />} /> */}
        <Route path={ROUTES.LOGIN_ROUTE} element={<Account />} />
        <Route path={ROUTES.ACCOUNT_ROUTE} element={<FormAppeal />} />
        <Route path={ROUTES.CHECKPOINT_ROUTE} element={<Checkpoint />} />
        <Route path={ROUTES.CHECKER_ROUTE} element={<Checker />} />

        <Route path="" element={<Navigate to={ROUTES.LOGIN_ROUTE} />} />
      </Routes>
    </Router>
  );
};

export default RootComponent;
